module.exports = __webpack_public_path__ + "img/加入协会.6f8f53b1.png";